// src/ui/assets/portraits.ts — Closed portrait asset registry (D-33).
//
// Adding a new portrait = adding an import + an enum entry = code change.
// V2-ADMIN-01 (in-admin upload) is out-of-scope for v1; Character.portraitId
// is validated by PortraitIdSchema (z.enum) so admin authors cannot reference
// a missing asset at publish time.
//
// Vite's `?url` suffix returns the final hashed URL string at build time
// (and a sourcefile-relative URL during `vitest` / `vite dev`). The leading
// `/assets/portraits/...` path resolves against the project's public/ directory.
//
// Source: .planning/phases/05-content-pipeline-characters-admin-cms/05-CONTEXT.md D-33 / D-34;
//         05-PATTERNS.md src/ui/assets/portraits.ts entry.
import eddyPortrait from '/assets/portraits/eddy.png?url';
import charliePortrait from '/assets/portraits/charlie.png?url';
import checkaPortrait from '/assets/portraits/checka.png?url';
import tommyPortrait from '/assets/portraits/tommy.png?url';
import teresinhaPortrait from '/assets/portraits/teresinha.png?url';
import zePortrait from '/assets/portraits/ze.png?url';
import maryPortrait from '/assets/portraits/mary.png?url';
import fikiPortrait from '/assets/portraits/fiki.png?url';
import gusPortrait from '/assets/portraits/gus.png?url';
import williamPortrait from '/assets/portraits/william.png?url';
import bennyPortrait from '/assets/portraits/benny.png?url';
import silhouetteFallback from '/assets/portraits/_silhouette-fallback.png?url';

import type { PortraitId } from '../../shared/content/types';

export const PORTRAITS: Record<PortraitId, string> = {
  eddy: eddyPortrait,
  charlie: charliePortrait,
  checka: checkaPortrait,
  tommy: tommyPortrait,
  teresinha: teresinhaPortrait,
  ze: zePortrait,
  mary: maryPortrait,
  fiki: fikiPortrait,
  gus: gusPortrait,
  william: williamPortrait,
  benny: bennyPortrait,
};

export const SILHOUETTE_FALLBACK: string = silhouetteFallback;

/**
 * Resolve a portrait id to its Vite-built URL. Returns the silhouette
 * fallback when the id is not a known PortraitId — defensive default per
 * UI-SPEC §Layout Contracts (Character card portrait fallback).
 *
 * Uses `Object.prototype.hasOwnProperty.call` rather than the `in` operator
 * so prototype-chain keys like `toString` / `constructor` don't shortcut to
 * a function reference that breaks the `<img src=…>` consumer.
 */
export function resolvePortrait(id: string): string {
  return Object.prototype.hasOwnProperty.call(PORTRAITS, id)
    ? PORTRAITS[id as PortraitId]
    : SILHOUETTE_FALLBACK;
}
